import { render, staticRenderFns } from "./DriverEdit.vue?vue&type=template&id=1d572bf9"
import script from "./DriverEdit.vue?vue&type=script&lang=js"
export * from "./DriverEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports